import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, from } from 'rxjs';
import { CacheService } from '../../utils/cache.service';


export const ESTENSA_MODULE_COMMON_APPLICATION_SETTINGS_SERVICE = new InjectionToken('estensa.module.common-application-settings.service');

export class NullCommonApplicationSettingsService {
    getAsJSON() {
        return Promise.resolve({
            serializableCulture: {
                cultureName: 'it-IT',
                shortDatePattern: 'dd/MM/YYYY',
                shortTimePattern: 'HH:mm',
            }
        });
    }
}

@Injectable({
    providedIn: 'root',
})
export class CommonApplicationSettingsService {

    constructor(@Inject(ESTENSA_MODULE_COMMON_APPLICATION_SETTINGS_SERVICE) private settingsService,
                private cacheService: CacheService) { }

    getSettings(): Observable<any> {
        return this.cacheService.get(
            'CommonApplicationSettings',
            from(this.settingsService.getAsJSON()),
        );
    }
}
